import ApiService from "../../../../commons/services/ApiService";
import CompanyAPI from "../../../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class TrichoAPI {

  URI_V1 = "/v1/tricho"

  create = async (formData: any) => {
    return await apiService.postFormData(`${this.URI_V1}?companyId=${companyAPI.getCompanyManagment().id}`, formData);
  };

  update = async (id: any, formData: any) => {
    return await apiService.putFormData(`${this.URI_V1}/${id}?companyId=${companyAPI.getCompanyManagment().id}`, formData);
  };


  fetchTrichoAnalyses = async () => {
    return await apiService.get(`${this.URI_V1}/analyses?companyId=${companyAPI.getCompanyManagment().id}`);
  };

  deleteAnalyseById = async (analyseId: any) => {
    return await apiService.delete(`${this.URI_V1}/analyses/${analyseId}`);
  };

  getById = async (id: any) => {
    return await apiService.get(`${this.URI_V1}/${id}?companyId=${companyAPI.getCompanyManagment().id}`);
  };

  generatedIA = async (formData: any) => {
    return await apiService.postFormData(`${this.URI_V1}/generate-ia`, formData);
  };

  generatedIAByUrl = async (imageUrl: any) => {
    return await apiService.post(`${this.URI_V1}/generate-ia-url?imageUrl=${imageUrl}`, null);
  };

  getAllByAnamneseResponseId = async (anamneseResponseId: any) => {
    return await apiService.get(`${this.URI_V1}/anamnese/${anamneseResponseId}`);
  };

  
  
}
